import translations from "../translations/translations.json";

function capitalize(word) {
	return word
	  .split('')
	  .map((letter, index) =>
		index ? letter.toLowerCase() : letter.toUpperCase(),
	  )
	  .join('');
  }
export const translator = (currentLanguage, code, caps = true) => {
	if(!currentLanguage){
		currentLanguage='EN';
	}
	let result = '';
	if (translations && translations[currentLanguage] && translations[currentLanguage][code]) {
		result = translations[currentLanguage][code];
	}else{
		console.warn("Translations: no translation found for (" + code + ")");
		result = code?.replace('_',' ')?.replace('_',' ')?.replace('_',' ');
	}

	if(caps){
		result = capitalize(result);
	}
	return result;
};

export default translator;
